import React, { useState, useEffect } from 'react';
import { calcRatio, displayLoader } from '../../utils';


/**
 * Game Stats Widget:
 * Goals, Yellow Cards, Red Cards, Substitutions
 */
const GameStatsWidget = (props) => {
    const { 
        awayName = '', 
        homeName = '', 
        stats = null,
        ...restProps 
    } = props;
    const [ isLoaded, setLoaded ] = useState(false);
    const [ classList, setClassList ] = useState('acaWidget acaWidget--gameStats');

    useEffect( () => {
        if ( stats instanceof Array ) {
            setLoaded(true);
            if ( !stats.length ) {
                setClassList(classList + ' acaWidget--emptyStats');
            }
        }
    }, [stats]);

    // Return nothing if we don't have any data yet
    if ( !isLoaded ) return;

    // Else return the list of stats
    return (
        <div className={classList}>
            <div className="acaH4 acaWidget__title">Game Stats</div>
            <div className="acaWidget__inner">
                <div className="acaWidget__innerTitles">
                    <h5 className="acaH5 acaWidget__innerTitle acaWidget__innerTitle--home">{homeName}</h5>
                    <h5 className="acaH5 acaWidget__innerTitle acaWidget__innerTitle--away">{awayName}</h5>
                </div>
                { !stats.length ? ( <div className="acaWidget__emptyNotice">No game stats are currently available</div> ) 
                : stats.map((item, i) => { 
                    return (
                        <GameStatsItem 
                            key = {i}
                            name = {item.name}
                            slug = {item.slug}
                            away = {item.away}
                            home = {item.home}
                        />
                    );
                } ) }
            </div>
        </div>
    );
}

/**
 * Game Stats Inner Item
 */
const GameStatsItem = (props) => {
    const { 
        slug = '', 
        name = '', 
        away = '', 
        home = '', 
        ...restProps 
    } = props;
    const ratio = calcRatio(home, away);

    return (
        <div className={"acaWidgetItem acaWidgetItem--" + slug}>
            <span className="acaWidgetItem__counter acaWidgetItem__counter--home">{home}</span>
            <div className="acaWidgetItem__bar__wrapper">
                <h5 className="acaH5--alt acaWidgetItem__title">{name}</h5>
                <span className="acaWidgetItem__bar" style={{"--ratio": ratio}}></span>
            </div>
            <span className="acaWidgetItem__counter acaWidgetItem__counter--away">{away}</span>
        </div>
    );
}

export { GameStatsWidget };